import { render, staticRenderFns } from "./AnswerStatisticTableItem.vue?vue&type=template&id=10764e00&scoped=true"
import script from "./AnswerStatisticTableItem.vue?vue&type=script&lang=js"
export * from "./AnswerStatisticTableItem.vue?vue&type=script&lang=js"
import style0 from "./AnswerStatisticTableItem.vue?vue&type=style&index=0&id=10764e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10764e00",
  null
  
)

export default component.exports